import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import useCertificateOfOriginStore from "../../../../stores/certificateOfOriginStore";

export default function useExporterForm() {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const currentCertifier = useCertificateOfOriginStore((s) => s.certifier);
  const currentExporter = useCertificateOfOriginStore((s) => s.exporter);

  const initialValues = useMemo(
    () => ({
      name: currentExporter?.name || (currentCertifier.role === "exporter" && currentCertifier.name) || "",
      email: currentExporter?.email || (currentCertifier.role === "exporter" && currentCertifier.emailAddress) || "",
      address: currentExporter?.address || (currentCertifier.role === "exporter" && currentCertifier.address) || "",
      phoneNumber: currentExporter?.phoneNumber || (currentCertifier.role === "exporter" && currentCertifier.phoneNumber) || "",
    }),
    [currentExporter, currentCertifier],
  );

  const handleSubmit = useCallback(
    (values, { setSubmitting }) => {
      setSubmitting(true);
      useCertificateOfOriginStore.getState().setExporter(values);
      navigate("/dashboard/certificate-of-origin/generate/producer-data/");
      setSubmitting(false);
    },
    [navigate],
  );

  useEffect(() => {
    if (!currentCertifier) {
      Swal.fire({
        title: "Error!",
        text: "Please provide certifier information first.",
        icon: "error",
      }).then(() => {
        navigate("/dashboard/certificate-of-origin/generate/certifier-form/", { replace: true });
      });
    } else {
      setLoading(false);
    }

    return () => setLoading(true);
  }, [navigate, currentCertifier]);

  return useMemo(() => ({ loading, handleSubmit, initialValues }), [loading, handleSubmit, initialValues]);
}
